import React from 'react';
import ChaptersHero from '../components/chapters/ChaptersHero';
import ChaptersGrid from '../components/chapters/ChaptersGrid';

const ChaptersPage = () => (
  <main>
    <ChaptersHero />
    <ChaptersGrid />
  </main>
);

export default ChaptersPage;